import axios from 'axios';

import type { IPotentialFindParams, IPotentialUpdateBody, TPotentialCardRoute } from '../types/potential';

export const createPotentialApi = (route: TPotentialCardRoute) => ({
  find: (params: IPotentialFindParams) =>
    axios.get(`/api/${route}/find/${params.potentialId}`, {
      params: { exportId: params.exportId, importId: params.importId },
    }),
  update: (potentialId: number, body: IPotentialUpdateBody) =>
    axios.put(`/api/${route}/update?id=${potentialId}`, {
      potentialId: body.potentialId,
      exportId: body.exportId,
      importId: body.importId,
      potentialValue: body.potentialValue,
      importValue: body.importValue,
      exportValue: body.exportValue,
    }),
});
